export class LoadReports {
    static readonly type = '[Report] Load Reports';
}

export class RequestReport {
    static readonly type = '[Report] Request Report';
    constructor(public email: string) {}
}

export class DownloadReport {
    static readonly type = '[Report] Download Report';
    constructor(public reportName: string) {}
}

export class DownloadLegacyReport {
    static readonly type = '[Report] Download Legacy Report';
}
